import { useState, useEffect } from 'react';
import './UserCard.scss';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import AnimatedPulse from '../../../components/Loading/AnimatedPulse/AnimatedPulse';
import { useLogoutMutation } from '@project/store/services/authApi';
import config from '../../../config';

interface UserCardProps {
  name: string;
  isInstitution?: Boolean; //we need to identify whether to display one or two initials
  userId?: string;
}

function UserCard({ name, isInstitution = false }: UserCardProps) {
  const [logout] = useLogoutMutation();
  //const [loginBackAsAdmin, adminFormStatus] = useLoginBackAsAdminMutation();
  const [initials, setInitials] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState: boolean) => !prevState);

  const handleLogout = async () => {
    try {
      await logout('').unwrap();
    } catch (err: any) {
      console.warn('Logout failed', err);
    } finally {
      document.cookie = 'x-token=; Max-Age=0; path=/;';
      document.cookie = 'r-token=; Max-Age=0; path=/;';
      window.location.replace(`${config.subsitesUrl.main}/login/redirect/${config.subsiteCode}`);
    }
  };

  useEffect(() => {
    if (name) {
      const nameArray = name.split(' ').filter((s) => s && s != '');
      if (!isInstitution) setInitials(`${nameArray[0][0]}${nameArray.length > 1 ? nameArray[1][0] : ''}`.toLocaleUpperCase());
      else setInitials(`${nameArray[0][0]}`.toLocaleUpperCase());
    }
  }, [name]);

  return (
    <div className="user-card-wrapper">
      <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={'down'}>
        <DropdownToggle caret>
          {name ? (
            <div className="user-info-avatar-wrap flex flex-row">
              <div className="user-avatar">{initials}</div>
            </div>
          ) : (
            <AnimatedPulse color="blue" />
          )}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem>
            <div className="user-info-avatar-wrap flex">
              <div className="user-avatar">{initials}</div>
              <div className="user-name-wrap text-capitalize">{name}</div>
            </div>
          </DropdownItem>
          <DropdownItem onClick={handleLogout}>
            <i className="icon icon-logout" /> Log out
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default UserCard;
